import React from 'react';
import { useTranslation } from 'react-i18next';
import { DEMO_QUESTIONNAIRE_PAPERS } from '../../../data/demoTestPaper';
import AbilityPaperMenu from '../../test/AbilityPaperMenu';
import { getCurrentLanguage } from '../../../utils/languageUtils';

const PromotionalAbilityMenuEmbed = () => {
  const { t, i18n } = useTranslation();
  const lang = getCurrentLanguage() || i18n.language || 'en';

  return (
    <div className="rounded-3xl overflow-hidden shadow-2xl border border-edge bg-surface">
      <div className="promo-ability-embed max-h-[min(420px,70vh)] overflow-y-auto">
        <AbilityPaperMenu
          embedded
          t={t}
          lang={lang}
          papers={DEMO_QUESTIONNAIRE_PAPERS}
          completedSlugs={[]}
          progressBySlug={{}}
          onSelectPaper={() => {}}
        />
      </div>
    </div>
  );
};

export default PromotionalAbilityMenuEmbed;
